import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import classes from "../../css/LoginForm.module.scss";
import logo from "../../assets/mamviewer1.png";
import signalProviderIcon from "../../assets/Group 8.svg";
import { useTranslation } from "react-i18next";
import swal from "sweetalert2";
import loginService from "../../services/login";
import userService from "../../services/user";
import LoadingLogin from "../gadgets/loadingLogin"
import Show from "../../assets/show.png";
import Hide from "../../assets/hide.png";
import { urls } from "../../config/urls";
import { baseEnv, server } from "../../App";

function LoginForm(props) {

    //-----------------------------------------------------------------------
    // Hooks, const and variables declaration
    //-----------------------------------------------------------------------

    const [t] = useTranslation("global");
    const [usu, setUsu] = useState("");
    const [pass, setPass] = useState("");
    const [accTyp, setAccTyp] = useState("");
    const [loading, setLoading] = useState(false);
    const [showUrl, setShowUrl] = useState(false);
    const [plat, setPlat] = useState({servers: {demo: "hola"}});
    const [showServer, setShowServer] = useState(true);
    const [show, setShow] = useState(false);
    const [ser, setSer] = useState("");
    const [ip, setIp] = useState("");
    const [market,setMarket] = useState("");
    const [secondListValue, setSecondListValue] = useState('notValid');
    const navigate = useNavigate();
    const env = process.env.REACT_APP_URL;
    let url = "";
    
    
    const cookies = new Cookies();
    let title = "";

    //-----------------------------------------------------------------------
    // Credentials and token cookies deleted
    //-----------------------------------------------------------------------

    cookies.remove("user", { path: '/' });
    cookies.remove("account type", { path: '/' });
    cookies.remove("token", { path: '/' });
    cookies.remove("plat", { path: '/' });


    //-----------------------------------------------------------------------
    // Checking out MT version for showing in views and login parameter
    //-----------------------------------------------------------------------  

    /*//const envCutted = env.substring(0, 21);
    //if (envCutted === "https://mamviewer-mt4") {
    //    title = "login.Enter your Metatrader 4 credentials";
    //}
    //else if (envCutted === "https://mamviewer-mt5") {
    //    title = "login.Enter your Metatrader 5 credentials";
    //}
    //else if (env === "http://13.41.66.231:5005"){
    //    title = "login.Enter your Metatrader 5 credentials";
    //}*/

    //-----------------------------------------------------------------------
    // Credential validation handler
    //-----------------------------------------------------------------------
    const getIp = () => {
        setLoading(true);  //Starts loading spinning
        userService.getIpClient( //Calls the method getIpClient from user service (axios request)
        )
        .then(response=>{ //Waits for a response from the axios request
            setLoading(false);  //Stops loading spinning        
            return response;
        })
        .then(response=>{
            if(response !== null){ 
                setIp(response.data.ip); //If response is correct, sets ip into the hook ip.
            }
            else{
                console.log("not ip")
                getIp();
            }           
        })
        .catch(error => {
            setLoading(false); //Stops loading spinning  
            console.log(error);
            getIp();
        });
    };


    const handleLogin = async (e) => {      
        e.preventDefault();

        // Validates if login form was completly fill out
        if (usu.length === 0 || pass.length === 0 || accTyp.length === 0 || plat.name.length === 0 || market.length === 0) {
            swal.fire({
                text: t("login.Please, fill in the missing data"),
                icon: "warning",
                iconColor: "red",
                color: "#363636",
                background: "#FFFFFF",
                confirmButtonColor: "#FF0000"
            });
        }
        else{   
            //Calls login service to do login into the communitraders api 
            setLoading(true);                      
            loginService.login({
                //Login request body
                platform: plat.name,
                environment: server.name,
                role: accTyp,
                account: usu,
                password: pass,
                ip: ip,
                market: market,
            })
            .then(response=>{
                return response.data;
            })
            .then(response=>{
                //Checking out if the response return the login data
                if(response.data != null){ 
                    var user = response.data;  
                    cookies.set("token", user.token, { path: "/" });
                    
                    //If the response was correct, the credentials hooks are deleted                           
                    setUsu("");
                    setPass("");
                    let loginMessage = "" ;

                    // Checks out if the account type is signal or follower
                    if(accTyp === "master"){
                        //If the account type is signal, set the cookies with the access data (user, account type and token)
                        cookies.set("user", usu, { path: "/" });
                        cookies.set("account type", accTyp, { path: "/" });
                        //If the account type is signal the disclouser screen will be displayed                          
                        loginMessage = "login.Welcome Master user";   
                        navigate(baseEnv + "/Master");             
                    }
                    else if(accTyp === "sub") {   
                        //If the account type is follower, set the cookies with the access data (user, account type and token)                                   
                        cookies.set("user", usu, { path: "/" });
                        cookies.set("account type", accTyp, { path: "/" });                       
                        loginMessage = "login.Welcome sub account user"; 
                        navigate(baseEnv + "/Subaccount");                    
                    }
                    //Show an alert message and redirect to disclouser screen
                    swal.fire({
                        text: t(loginMessage),
                        icon: "success",
                        iconColor: "green",
                        color: "#363636",
                        background: "#FFFFFF",
                        confirmButtonColor: "#FF0000"
                    });                 
                //if the response is null a warning will be displayed
                }else{
                    swal.fire({
                        text: t("login.Invalid access credentials"),
                        icon: "error",
                        iconColor: "red",
                        color: "#363636",
                        background: "#FFFFFF",
                        confirmButtonColor: "#FF0000"
                    }); 
                }
            })
            .catch(error => {
                console.log(error);
                swal.fire({
                    text: t("login.Bad request, please check your account information"),
                    icon: "error",
                    iconColor: "red",
                    color: "#363636",
                    background: "#FFFFFF",
                    confirmButtonColor: "#FF0000"
                }); 
                setLoading(false);
            })                                          
        }                                            
    }

    //-----------------------------------------------------------------------
    // Create a new signal provider (Become a signal provider)
    //-----------------------------------------------------------------------

    const handleBecomeSignal = async (e) => {      
        e.preventDefault();

        // Validates if login form was completly fill out
        if (usu.length === 0 || pass.length === 0) {
            swal.fire({
                text: t("login.Please, fill in the missing data"),
                icon: "warning",
                iconColor: "red",
                color: "#363636",
                background: "#FFFFFF",
                confirmButtonColor: "#FF0000"
            });
        }
        else{   
            //Calls login service to do login into the communitraders api 
            setLoading(true);                     
            loginService.createMaster({
                //Login request body
                platform: env,
                environment: server,
                account: usu,
                password: pass,
                ip: ip,
            })          
            .then(response=>{
                return response.data;
            })
            .then(response=>{
                //Checking out if the response return the login data
                if(response.data != null){ 
                    //If the response was correct, the credentials hooks are deleted                           
                    //Show an alert message and redirect to disclouser screen
                    swal.fire({
                        text: t("login.Signal Provider created. Please, use the credential to log in"),
                        icon: "success",
                        iconColor: "green",
                        color: "#363636",
                        background: "#FFFFFF",
                        confirmButtonColor: "#FF0000"
                    });
                    navigate(baseEnv + "/Disclouser");
                //if the response is null a warning will be displayed
                }else{
                    swal.fire({
                        text: t("login.Invalid access credentials"),
                        icon: "error",
                        iconColor: "red",
                        color: "#363636",
                        background: "#FFFFFF",
                        confirmButtonColor: "#FF0000"
                    }); 
                }
            })
            .catch(error => {
                console.log(error);
                if(error.response.data.message === "This account is already a Signal Provider"){
                    swal.fire({
                        text: t("This account is already a Signal Provider"),
                        icon: "error",
                        iconColor: "red",
                        color: "#363636",
                        background: "#FFFFFF",
                        confirmButtonColor: "#FF0000"
                    }); 
                } 
                else{
                    swal.fire({
                        text: t("login.Internal Server Error"),
                        icon: "error",
                        iconColor: "red",
                        color: "#363636",
                        background: "#FFFFFF",
                        confirmButtonColor: "#FF0000"
                    }); 
                }       
                setLoading(false);
            })                                          
        }                                            
    }

    // Function in charge of limit the number of characters in an input

    function enforceMinMax(el) {
        if (el.value !== "") {
            if (parseInt(el.value.length) > parseInt(el.max.length)) {  
            el.value = el.value.slice(0, el.max.length)
          }
          if (parseInt(el.value) < parseInt(el.min)) {
            el.value = el.min
          }
        }
      };

    // Function to handler when a user click on show password button in login form, allows to see the password written by user
    const showPassword = (e) => {
        setShowUrl(!showUrl);
        var tipo = document.getElementById("user-password");
        if(tipo.type === "password"){
            tipo.type = "text";
        }else{
            tipo.type = "password";
        }
    }

    // handler to validate the value of platform or server in login platform and server combobox, this handlers sets if showing or not
    // the servers depending of the platform, also this handler sets the platform cookie.
    const choosePlatform = (e) => {
        setSecondListValue("notValid");
        if(e === "notValid"){
            setShowServer(true);
        }
        else{
            setShowServer(false);
            cookies.set("platform", e, { path: "/" });
            for (const platformKey in window.MainSettings.platforms) {
                if (window.MainSettings.platforms.hasOwnProperty(platformKey)) {
                  if(platformKey === e){
                    const platform = window.MainSettings.platforms[platformKey];
                    setPlat(platform);
                  }                 
                }
              }           
        }
    }

    const chooseServer = (e) => {
        cookies.remove("url", { path: '/' });
        setSecondListValue(e);
        if(e === "notValid"){
        }
        else{
            setShowServer(false);           
            for (const serverKey in plat.servers) {
                if (plat.servers.hasOwnProperty(serverKey)) {
                  if(serverKey === e){
                    const server = plat.servers[serverKey];
                    cookies.set("url", server.url, { path: "/" });
                    setMarket(server.type);
                    //Function event sender with the new url value
                    const urlUpdatedEvent = new CustomEvent('updatedUrl', {
                    detail: { value: server.url }
                    });
                    window.dispatchEvent(urlUpdatedEvent);
                  }                 
                }
              }           
        }
    }

    //USe Effect hook triggered once per render, it calls a function to request the user ip
    useEffect(() => {
        getIp();
    }, []);

    //USe Effect hook triggered each time the server or platform is changed in login form, it makes a validation to save and sending the
    // event with the change of cookie with the new url where the web is aiming
    useEffect(() => {
        //cookies.remove("url", { path: '/' });
        switch (plat){
            case "mt4":
                if(ser === "live-1"){
                    url = urls.mt4Live1;
                    cookies.set("url", urls.mt4Live1, { path: "/" });
                    setMarket("");
                }
                else if(ser === "live-2"){
                    url = urls.mt4Live2;
                    cookies.set("url", urls.mt4Live2, { path: "/" });
                    setMarket("");
                }
                else if(ser === "demo"){
                    url = urls.mt4Demo;
                    cookies.set("url", urls.mt4Demo, { path: "/" });
                    setMarket("");
                }
                else if(ser === "test"){
                    url = urls.mt4Test;
                    cookies.set("url", urls.mt4Test, { path: "/" });
                    setMarket("");
                }          
            break;

            case "mt5":
                if(ser === "live"){
                    url = urls.mt5Live;
                    cookies.set("url", urls.mt5Live, { path: "/" });
                    setMarket("forex");
                }
                else if(ser === "demo"){
                    url = urls.mt5Demo;
                    cookies.set("url", urls.mt5Demo, { path: "/" });
                    setMarket("forex");
                }
                else if(ser === "test"){
                    url = urls.mt5Test;
                    cookies.set("url", urls.mt5Test, { path: "/" });
                    setMarket("forex");
                }
                else if(ser === "live-stocks"){
                    url = urls.mt5Live;
                    cookies.set("url", urls.mt5Live, { path: "/" });
                    setMarket("stocks");
                }
                else if(ser === "demo-stocks"){
                    url = urls.mt5Demo;
                    cookies.set("url", urls.mt5Demo, { path: "/" });
                    setMarket("stocks");
                }
                else if(ser === "test-stocks"){
                    url = urls.mt5Test;
                    cookies.set("url", urls.mt5Test, { path: "/" });
                    setMarket("stocks");
                }
                
            break;

            default:
            break;
        }
        //Function event sender with the new url value
        const urlUpdatedEvent = new CustomEvent('updatedUrl', {
            detail: { value: url }
          });

          window.dispatchEvent(urlUpdatedEvent);
    }, [plat, ser]);

    //Render of html login components
    return (

        <div className={classes.formContainer}>
            <LoadingLogin loading={loading}/>
            <div className={classes.logoContainer}>
                <img
                    className={classes.logo}
                    src={logo}
                    alt="Logo"
                    htmlFor="logo-image"
                ></img>
            </div>
            <form className={classes.form} id="form" >
                <title className={classes.loginTitle}>{t("login.Enter your Metatrader credentials")}</title>
                <div>                   
                    <label className='settingLabel'>{t("master.Login")}</label>
                    <input
                        className={classes.input}
                        type="number"
                        id="user-name"
                        name="user-name" 
                        min="0"
                        max="999999999999999"
                        onKeyUp={(e) => enforceMinMax(e.target)}
                        onChange={(e) => setUsu(e.target.value)}
                        required
                        disabled={loading}
                    ></input>
                </div>

                <div className={classes.input_wrapper}>
                    <label className='settingLabel'>{t("login.Password")}</label>
                    <input
                        className={classes.input}
                        type="password"
                        id="user-password"
                        name="user-password"
                        autoComplete="off"
                        max="99999999999999999999"
                        onKeyUp={(e) => enforceMinMax(e.target)}
                        onChange={(e) => setPass(e.target.value)}
                        required
                        disabled={loading}
                    ></input>
                    <button className={classes.showPassword} type='button' onClick={(e) => showPassword()}>
                            <img
                             src={showUrl === false ? Show : Hide}
                             alt="show Icon"
                            htmlFor="show-icon" />
                    </button>
                </div>
                <div>
                    <label className='settingLabel'>{t("login.Account Type")}</label>
                    <select
                        className={classes.input}
                        id="account-type"
                        name="account-type"
                        onChange={(e) => setAccTyp(e.target.value)}
                        required
                        disabled={loading}
                    >
                        <option value="">{t("login.Select an account type")}</option>
                        <option value="sub">{t("login.Sub Account")}</option>
                        <option value="master">{t("login.Master")}</option>
                    </select>
                </div>
                <div>
                    <label className='settingLabel'>{t("login.Platform")}</label>
                    <select
                        className={classes.input}
                        id="platform"
                        name="platform"
                        onChange={(e) => choosePlatform(e.target.value)}
                        required
                        disabled={loading}
                    >
                        <option value="notValid">{t("login.Select a platform")}</option>
                        {Object.entries(window.MainSettings.platforms).map(([key, value]) => (
                            <option key={key} value={key}>
                                {value.name}
                            </option>
                        ))}
                    </select>
                </div>
                <div>
                    <label className='settingLabel' hidden={showServer}>{t("login.Server")}</label>
                    <select
                        className={classes.input}
                        id="server"
                        name="server"
                        onChange={(e) => chooseServer(e.target.value)}
                        required
                        hidden={showServer}
                        disabled={loading}
                        value={secondListValue}
                    >
                        <option value="notValid">{t("login.Select a server")}</option>
                        {Object.entries(plat.servers).map(([key, value]) => (
                            <option key={key} value={key}>
                                {value.name}
                            </option>
                        ))}
                    </select>
                </div>
                

                <button
                    className={classes.loginBtn}
                    onClick={handleLogin}
                    disabled={loading}
                >
                    {t("login.Login")}
                </button>
            </form>
        </div>
    );

}

export default LoginForm;
